module.exports = __webpack_public_path__ + "img/part5-1.bd6c5b88.png";